export default __webpack_public_path__ + "static/media/af2.8a964340.jpg";